import { setOnLoginPath } from "actions/open";
import { push } from "connected-react-router";
import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import authenticationStatusSelector from "selectors/authenticationStatus";
import onLoginPathSelector from "selectors/onLoginPath";

export default function GuardAuthenticationStatus(
    status: "authenticated" | "unauthenticated"
): void {
    const dispatch = useDispatch();
    const location = useLocation();
    const authenticationStatus = useSelector(authenticationStatusSelector);
    const onLoginLocation = useSelector(onLoginPathSelector);
    React.useEffect(() => {
        if (status !== authenticationStatus) {
            // Need to dispatch the thing...
            if (authenticationStatus === "authenticated") {
                dispatch(push(onLoginLocation || "/home"));
            } else if (authenticationStatus === "unauthenticated") {
                dispatch(setOnLoginPath(location.pathname + location.search));
                dispatch(push("/welcome"));
            }
        }
    }, [status, dispatch, authenticationStatus, location, onLoginLocation]);
}
